import { createFileRoute } from '@tanstack/react-router';
import { HealthCheckinScreen } from '../../screens/health/HealthCheckin';

export const Route = createFileRoute('/health/checkin')({
  component: HealthCheckinScreen,
});
